import { render, staticRenderFns } from "./RegisterAgreement.vue?vue&type=template&id=2881969c&scoped=true&"
import script from "./RegisterAgreement.vue?vue&type=script&lang=ts&"
export * from "./RegisterAgreement.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterAgreement.vue?vue&type=style&index=0&id=2881969c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2881969c",
  null
  
)

export default component.exports